import React from 'react';
import Ad from '../Ad';
type Props = {};

const AdContainer = (props: Props) => {
  return <Ad />;
};

export default AdContainer;
